<script>
import CustomersApi from "@/services/customers-api";
import CountriesApi from "@/services/countries-api";
import simplebar from "simplebar-vue";
import ReportingApi from "@/services/reporting-api";

export default {
    components: {
        simplebar
    },
    props: {
        isReportingPage:{
            type:Boolean,
            default:false,
        },
        isHomePage:{
            type:Boolean,
            default:false,
        },

        isCatalogPage: {
            type:Boolean,
            default:false,
        },

        firstDay:{
            type:String,
            default:null
        },
        lastDay:{
            type:String,
            default:null
        }

    },
    mounted(){
        this.role=sessionStorage.getItem("userr");
        if(this.role != 0){
            this.getCustomers()
        }
        this.getCountries();
        this.getTotalSales()
        this.getTopTenItems()

    } ,
    data () {
        return {
            isTableLoading:false,
            total:null,
            start:this.firstDay,
            end:this.lastDay,
            customersList:[],
            selectedCustomer:null,
            selectedCountry:null,
            selectedCity:null,
            citiesList:[],
            countriesList:[],
            // showClientsList:false,
            // showCountriesList: false,
            // showCitiesList:false,
            pagemodel: {currentPage : 1, perPage :10, totalRows: 0},
            role:null,
            topItems: [
            ],
            isGetTopItemsStarting:false,
            firstItemRef:null,
            firstItemSum:0,
            forceRenderSimpleBar:false,

        }
    },

    methods: {
        getTopTenItems(){
            this.isGetTopItemsStarting=true
            ReportingApi.getTopTenItems(this.pagemodel.currentPage, this.pagemodel.perPage,this.start,this.end,
            this.selectedCountry==null ? null : this.selectedCountry.id,this.selectedCity==null ? null : this.selectedCity.id,this.selectedCustomer==null ? null : this.selectedCustomer.id).then(
                (result) => {
                    this.topItems=result.list;
                    this.pagemodel.totalRows = result.total;
                    this.pagemodel.currentPage = result.page;
                    this.pagemodel.perPage = result.pageSize;
                    this.pagemodel.pageSize = result.pageSize;
                    if(this.pagemodel.currentPage == 1 && this.topItems.length){
                        this.firstItemRef=this.topItems[0].itemRef
                        this.firstItemSum=this.topItems[0].sumStr
                    }

                    this.forceRenderSimpleBar = true;
                    
                }
            ).finally(()=>{
                this.isGetTopItemsStarting=false
            })
        },

        getTotalSales(){
            ReportingApi.getTotalSales(this.start,this.end,this.selectedCountry==null ? null : this.selectedCountry.id,this.selectedCity==null ? null : this.selectedCity.id,this.selectedCustomer==null ? null : this.selectedCustomer.id).then(
                (result)=>{
                    this.total=result
                }
            )
        },

        getCustomers(){
        CustomersApi.getCustomers(this.selectedCountry==null ? null : this.selectedCountry.id,this.selectedCity==null ? null : this.selectedCity.id).then(
            response => {
            this.customersList=response;
            }
        )
        },
        getCountries(){
        CountriesApi.getCountries().then(
            result => {
                this.countriesList = result
            })
        },
        getCities(){
        CountriesApi.getCities(this.selectedCountry ? this.selectedCountry.id : null).then(
            result => {
                this.citiesList = result
            })
        },
    },
    watch: {
        end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getTopTenItems()
            this.getTotalSales()
          }
          
        },
        start: function(){
          if((this.end && this.start) || (!this.end  && !this.start)  ){
            this.getTopTenItems()
            this.getTotalSales()
          }
        },
        selectedCountry: function(){
          this.getTopTenItems()
          this.getTotalSales()
          this.getCustomers()
          if(this.selectedCountry != null){
            this.getCities()
          }else{
            this.selectedCity=null
            this.citiesList=[]
          }
        },
        selectedCity: function(){
            this.getCustomers()
            if(this.selectedCountry!=null){
                this.getTopTenItems()
                this.getTotalSales()
            }
        },
        selectedCustomer: function(){
            this.getTopTenItems()
            this.getTotalSales()
        }
    }
}
</script>

<template>
    <div :class="isReportingPage ? 'clearfix m-4' : ''">
        <div v-if="isReportingPage"  class="row">
            <div class="col-11">
                <h4 class="card-title mb-2 font-size-18 text-primary">{{$t("reporting.customer.topItems.title")}}  <span class="font-size-12"> ({{$t('reporting.customer.topItems.span')}})</span></h4>
            </div>
        </div>
        <div v-if="isReportingPage" >
            <div v-if="role==1" class="row mt-4">
                <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                    <b-form-group label="" label-for="">
                        <v-select :options="countriesList" :placeholder="$t('lists.countries.label')" label="name" v-model="selectedCountry">
                        <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                    <b-form-group label="" label-for="">
                        <v-select :options="citiesList" :placeholder="$t('lists.cities.label')" label="name" v-model="selectedCity">
                        <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12">
                    <b-form-group label="" label-for="">
                        <v-select :options="customersList" :placeholder="$t('lists.customers.label')" label="companyName" v-model="selectedCustomer">
                        <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>                    
                </div>
            </div>
            <div class="row" :class="role==1 ? '' : 'mt-4' " >
                <div class="col-xl-6 col-lg-6 col-md-12 col-cm-12 col-xs-12 pr-lg-2 ">
                <b-form-group  label-for="">
                    <b-form-datepicker
                    v-model="start"
                    :locale="$t('datPicker.locale')"
                    :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                    dark
                    reset-button
                    close-button
                    :label-reset-button="$t('datPicker.label-reset-button')"
                    :label-close-button="$t('datPicker.label-close-button')"
                    dropright
                    hide-header
                    ></b-form-datepicker>
                </b-form-group>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-cm-12 col-xs-12">
                <b-form-group  label-for="">
                    <b-form-datepicker
                    v-model="end"
                    :locale="$t('datPicker.locale')"
                    :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                    dark
                    reset-button
                    close-button
                    :label-reset-button="$t('datPicker.label-reset-button')"
                    :label-close-button="$t('datPicker.label-close-button')"
                    dropright                         
                    hide-header
                    ></b-form-datepicker>
                </b-form-group>
                </div>
            </div>

        </div>
        <div  class="text-center pb-4" :class="topItems.length && isReportingPage ? '' : 'd-none'">
            <div class="mb-2 mt-2 ">
            <i class="bx bx-star text-success display-4" style="font-size: 3.5em"></i>
            </div>
            <span vclass="text-success mb-1" style="font-size:1.75em">{{firstItemRef}}</span>
            <h3>{{firstItemSum}} </h3>
        </div >
        
        <simplebar v-if="forceRenderSimpleBar" :style="isCatalogPage ? {'max-height': '7.5em', 'min-height':'7.5em'} : !isHomePage && isReportingPage ? {'min-height': '23em', 'max-height' : '23em'} : {'min-height': '35em', 'max-height' : '35em'}  ">
            <div v-if="!isGetTopItemsStarting">
                <div v-for="topItem in this.topItems" class="row pl-1 pr-1 pl-sm-4 pr-sm-4 pb-2"  style=" align-items: center;" :key="topItem.id" >
            
                <div class="col-sm-3 col-3">
                    <span class="text-primary font-weight-bold">{{topItem.itemRef}}</span>
                </div>

                <div class="col-sm-6 col-3">
                    <b-progress 
                    :value="topItem.sum /total * 100" 
                    variant="success" 
                    height="6px" 
                />
                </div>

                <div class="col-sm-3 col-6 text-right">
                    <span class=" ">{{topItem.sumStr}} </span>
                </div>
                </div>
            </div>

            <div class="text-center" v-if="isGetTopItemsStarting" >
                <b-spinner variant="primary" ></b-spinner>
            </div>
            <div class="text-center" v-if="!isGetTopItemsStarting && (!topItems || !topItems.length)" >
                <div class="text-danger m-4" >{{$t('catalog.empty')}}</div>
            </div>

        </simplebar>

        <!-- Pagination -->
        <div class="row pt-3 pl-2 mb-sm-4" v-if="isReportingPage">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getTopTenItems();getTotalSales()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getTopTenItems();getTotalSales()" :disabled="isGetTopItemsStarting" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
    </div>
</template>